import DashboardTab from '@/components/dashboard/DashboardTab'

const Tab = () => {
  return <DashboardTab />
}

export default Tab
